import { useParams } from "react-router-dom";
import { categories } from "@/mocks/articles";
import CategoryHeader from "./components/CategoryHeader";
import CategoryArticles from "./components/CategoryArticles";
import CategoryPortal from "./components/CategoryPortal";
import NotFound from "@/pages/NotFound";
import { StructuredData, generateBreadcrumbLD, generateWebPageLD } from "@/components/base/StructuredData";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return <NotFound />;
  }

  const breadcrumbLD = generateBreadcrumbLD([
    { name: "首页", url: "http://cgiqwhk.cn/" },
    { name: category.name, url: `http://cgiqwhk.cn/category/${category.slug}` },
  ]);

  const webPageLD = generateWebPageLD(
    `${category.name} - 黑料吃瓜网`,
    `http://cgiqwhk.cn/category/${category.slug}`,
    category.description
  );

  return (
    <>
      <StructuredData data={breadcrumbLD} />
      <StructuredData data={webPageLD} />
      <CategoryHeader categorySlug={category.slug} />
      <CategoryArticles categorySlug={category.slug} categoryName={category.name} />
      <CategoryPortal categorySlug={category.slug} categoryName={category.name} />
    </>
  );
}